const scopes = [
  'agronomicPortfolios:read',
  'agronomicPortfolios:write',
  'brands:read',
  'crops:read',
  'jobs:read',
  'locations:read',
  'locations:write',
  'parties:read',
  'preferences:read',
  'preferences:write',
  'prerequisites:read',
  'prerequisites:write',
  'products:read',
  'schemas:read',
  'seeds:read',
  'user',
  'vendors:read'
];

export default scopes;
